import { useMemo } from 'react';
import BarChart from '../../../esp-dashboard/components/BarChart';
import './style.scss';

interface ParetoCardItemProps {
  count: number;
  heading: string;
  isPercent?: boolean;
}
interface ParetoProductionProps {
  count: Record<string, number>;
  chartData: any;
}
const xAxisLabelStyle = {
  fontSize: 12,
  color: '#F7F9F9',
  fontFamily: 'Mulish',
  fontWeight: '400' as const,
  lineHeight: 1.5, // 150% as a ratio (18px/12px = 1.5)
};
const ParetoCardItem: React.FC<ParetoCardItemProps> = ({ count, heading, isPercent }: ParetoCardItemProps) => {
  const formattedCount = count < 10 ? `0${count}` : count;

  return (
    <div className='pareto-card-item'>
      <div className='pareto-card-item__count'>
        {formattedCount}
        {isPercent ? '%' : ''}
      </div>
      <div className='pareto-card-item__heading'>{heading}</div>
    </div>
  );
};
const ParetoProduction: React.FC<ParetoProductionProps> = ({ count, chartData }: ParetoProductionProps) => {
  const cards = {
    ParetoCountWells80: 'Wells 80% oil',
    ParetoPercWells80: 'Wells 80% oil',
    ParetoCountWells80To90: 'Wells 80-90% oil',
    ParetoPercWells80To90: 'Wells 80-90% oil',
    ParetoCountWellsOver90: 'Wells last 1 month',
    ParetoPercOver90: 'Wells last 1 month',
  };
  const chartDataFormated = useMemo(() => {
    if (!chartData || typeof chartData !== 'object') {
      return [];
    }

    return [
      {
        category: 'Oil',
        value: chartData.Oil || 0,
        color: '#32D583',
      },
      {
        category: 'Fluid',
        value: chartData.Fluid || 0,
        color: '#32D583',
      },
    ];
  }, [chartData]);
  return (
    <div className='pareto-production'>
      <div className='pareto-production__title'>Pareto production</div>
      <div className='pareto-production__content'>
        <div className='pareto-cards-wrapper'>
          {Object.entries(cards).map(([key, heading]) => (
            <ParetoCardItem
              key={key}
              count={count?.[key] ?? 0}
              heading={heading}
              isPercent={key.startsWith('ParetoPerc')}
            />
          ))}
        </div>
        <div className='pareto-graph-wrapper'>
          <BarChart
            title='Field potential (bbls/day)'
            subtitle='Oil rate'
            yAxisLabel='Production (bbls/day)'
            data={chartDataFormated}
            showActionButtons={true}
            xAxisLabelStyle={xAxisLabelStyle}
            margin='0px'
            chartHeight='h-[240px]'
          />
        </div>
      </div>
    </div>
  );
};
export default ParetoProduction;
